<template>
	<div class="container mb-10vh">
		<div v-if="yhfCompanyList.length > 0">
			<table>
				<tr>
					<td>등록일</td>
					<td>기업명</td>
					<td>아이디</td>
					<td>채용담당자</td>
					<td>전화번호</td>
					<td>링크</td>
				</tr>
				<tr v-for="item in companyUserList">
					<td>{{ item.date | dateFormat }}</td>
					<td>{{ item.company }}</td>
					<td>{{ item.email }}</td>
					<td>{{ item.name }} {{ item.position }}</td>
					<td>{{ item.mobile }}</td>
					<td><a class="text-link" @click="autologin(item.email)">바로가기</a></td>
				</tr>
			</table>
			<div class="paging center">
				<div class="box-page deselected prev pointer" @click="goPrev()">
					<img src="/images/paging_left_1.svg" />
				</div>
				<div
					v-for="num in allNo"
					class="box-page pointer"
					:class="selectPage === num ? 'point' : ''"
					@click="go(num)"
				>
					{{ num }}
				</div>
				<div class="box-page deselected next pointer" @click="goNext()">
					<img src="/images/paging_right_1.svg" />
				</div>
			</div>
		</div>
		<div v-else>
			<div class="border text-center pd-50">
				<img class="sorry-logo" src="/images/co_sorry.svg" />
				<div class="sorry-font">참여기업 리스트 정보가 없습니다.</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: ['yhfCompanyList'],
	data() {
		return {
			pages: Math.ceil(this.yhfCompanyList.length / 10), //전체 페이지
			nowPages: Math.ceil(Math.ceil(this.yhfCompanyList.length / 10) / 5), //현재 페이지 전체 쪽
			nowPage: 1, //현재 페이지 쪽
			allNo: {}, //현재 페이지 쪽 숫자들
			selectPage: 1, //선택한 페이지 숫자
			companyUserList: {},
		};
	},
	mounted() {
		this.showPage();
		this.showTable();
	},
	methods: {
		showPage() {
			this.allNo = {};
			let cnt = 0;
			for (let i = (this.nowPage - 1) * 5; i < (this.nowPage - 1) * 5 + 5; i++) {
				if (i < this.pages) {
					this.allNo[cnt] = i + 1;
					cnt++;
				}
			}
		},
		showTable() {
			this.companyUserList = {};
			for (let i = (this.selectPage - 1) * 10; i <= (this.selectPage - 1) * 10 + 9; i++) {
				if (i < this.yhfCompanyList.length) {
					this.companyUserList[i] = this.yhfCompanyList[i];
				}
			}
		},
		goPrev() {
			if (this.nowPage > 1) {
				this.nowPage -= 1;
				this.selectPage = (this.nowPage - 1) * 5 + 1;
				this.showPage();
				this.showTable();
			}
		},
		goNext() {
			if (this.nowPage < this.nowPages) {
				this.nowPage += 1;
				this.selectPage = (this.nowPage - 1) * 5 + 1;
				this.showPage();
				this.showTable();
			} else {
				this.nowPage = this.nowPages;
				this.selectPage = (this.nowPage - 1) * 5 + 1;
				this.showPage();
				this.showTable();
			}
		},
		go(page) {
			this.selectPage = page;
			this.showTable();
		},
		autologin(email) {
			showLoading();

			axios({
				method: 'POST',
				url: '/api/yhf/autologin',
				data: {
					email: email,
				},
			}).then(response => {
				location.href = '/dashboard';
			});
		},
	},
};
</script>

<style lang="less" scoped>
.mb-10vh {
	margin-bottom: 10vh;
}
table {
	width: 100%;
	border-collapse: collapse;
	text-align: center;
}
table tr {
	height: 48px;
}
table tr:nth-child(1) {
	background-color: #f1f1f1;
	font-weight: 700;
}
table tr td {
	border: 1px solid #eaeaea;
}
.point {
	background-color: #2a7de1;
	color: white;
}
.sorry {
	&-logo {
		width: 120px;
		@media (max-width: 480px) {
			width: 100px;
		}
	}
	&-font {
		font-size: 20px;
		color: #949494;
		@media (max-width: 480px) {
			font-size: 16px;
		}
	}
}
</style>
